<div class="container content-area relative">
    <div class="page-header">
        <h4 class="page-title">Dashboard</h4>
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
        </ol>
    </div>

    <div class="row row-cards">
        
        <div class="col-sm-6 col-md-4 col-xl-4">
            <div class="card card-status-left-danger text-center">
                <div class="card-body cursor-hand" [routerLink]="['/admin/request/charges']">
                    <h6 class="mb-3">Pending Charge Update Request</h6>
                    <h2 class="mb-2 text-dark display-4 font-weight-bold">
                        <i class="fa fa-inr text-danger mr-2"></i>{{ data?.priceChangeRequests }}
                    </h2>
                </div>
            </div>
        </div>
        
        <div class="col-sm-6 col-md-4 col-xl-4">
            <div class="card card-status-left-warning text-center">
                <div class="card-body cursor-hand" [routerLink]="['/admin/request/profile']">
                    <h6 class="mb-3">Pending Profile Update Request</h6>
                    <h2 class="mb-2 text-dark display-4 font-weight-bold">
                        <i class="fe fe-user-check text-warning mr-2"></i>{{ data?.pendingProfileRequest }}
                    </h2>
                </div>
            </div>
        </div>
        
        <div class="col-sm-6 col-md-4 col-xl-4">
            <div class="card card-status-left-success text-center">
                <div class="card-body cursor-hand" [routerLink]="['/admin/astro/onoff']">
                    <h6 class="mb-3">Online Astro</h6>
                    <h2 class="mb-2 text-dark display-4 font-weight-bold">
                        <i class="fe fe-users text-success mr-2"></i>{{ data?.currentactiveastro }}
                    </h2>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-4 d-flex">
        <div class="col-md-5">
            <div class="card h-100 chart-card">
                <div class="card-body d-flex flex-column">
                    <h6 class="card-title-chart">
                        Today's Earnings Comparison
                        <small class="text-muted">
                            {{ today | date:'mediumDate' }}
                        </small>
                    </h6>
                    <div class="chart-container flex-grow-1">
                        <canvas #earningChart></canvas>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-md-7">
            <div class="card h-100 chart-card">
                <div class="card-body d-flex flex-column">
                    <h6 class="card-title-chart">
                        Today's Activity Breakdown
                        <small class="text-muted">
                            {{ today | date:'mediumDate' }}
                        </small>
                    </h6>
                    <div class="chart-container flex-grow-1">
                        <canvas #breakdownChart></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>